// @ts-nocheck
import { useEffect, useRef, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

export function usePresence(roomId?: string) {
  const [onlineUsers, setOnlineUsers] = useState<Record<string, number>>({});
  const [isOnline, setIsOnline] = useState(false);
  const heartbeatRef = useRef<number | null>(null);

  useEffect(() => {
    let channel = supabase.channel(`presence-${roomId || 'global'}`, { config: { presence: { key: 'presence' } } });

    channel.on('presence', { event: 'sync' }, () => {
      const state = channel.presenceState();
      const map: Record<string, number> = {};
      Object.values(state).forEach((arr: any) => {
        arr.forEach((entry: any) => {
          if (entry.user_id) map[entry.user_id] = Date.now();
        });
      });
      setOnlineUsers(map);
    });

    channel.subscribe(async (status) => {
      if (status === 'SUBSCRIBED') {
        const { data: user } = await supabase.auth.getUser();
        const id = user.user?.id;
        if (id) {
          await channel.track({ user_id: id, ts: Date.now(), room: roomId || 'global' });
          setIsOnline(true);
        }
      }
    });

    heartbeatRef.current = window.setInterval(async () => {
      const { data: user } = await supabase.auth.getUser();
      const id = user.user?.id;
      if (id) await channel.track({ user_id: id, ts: Date.now(), room: roomId || 'global' });
    }, 30000);

    return () => {
      if (heartbeatRef.current) clearInterval(heartbeatRef.current);
      channel.unsubscribe();
      setIsOnline(false);
    };
  }, [roomId]);

  return { onlineUsers, isOnline };
}


